import { ElementType } from 'react'
import { observer } from 'mobx-react-lite'
import { Outlet } from '@tanstack/react-router'

import { WebApp, WebAppProps } from '@authy/lib-web/app'

import { Navigation } from './Navigation'

type AdminAppProps = Omit<WebAppProps, 'navigation'> & {
    NavigationHeader?: ElementType
    NavigationCanvas?: ElementType
}

export const AdminApp = observer(({ NavigationHeader, NavigationCanvas, children }: AdminAppProps) => {
    return (
        <WebApp>
            <div className="flex h-full min-h-full flex-col md:flex-row">
                <Navigation Header={NavigationHeader} Canvas={NavigationCanvas} />
                <div className="flex flex-1 flex-col overflow-hidden bg-white md:mb-2 md:mr-2 md:mt-2 md:rounded md:shadow-[0px_0.5px_2px_rgba(0,0,0,0.30)] dark:bg-neutral-900 dark:md:shadow-[0px_0px_1px_rgba(255,255,255,0.5)]">
                    <Outlet />
                </div>
                {children}
            </div>
        </WebApp>
    )
})
